import { toastEventBus } from './toastEventBus';

interface ToastProps {
  toastMessage: string;
  toastDescription?: string;
  autoClose?: number | false;
}

export const handleSuccessToast = ({
  toastMessage,
  toastDescription,
  autoClose = 5000,
}: ToastProps) => {
  toastEventBus.emit({
    severity: 'success',
    message: toastMessage,
    description: toastDescription,
    autoClose,
  });
};

export const handleErrorToast = ({
  toastMessage,
  toastDescription,
  autoClose = 5000,
}: ToastProps) => {
  toastEventBus.emit({
    severity: 'error',
    message: toastMessage,
    description: toastDescription,
    autoClose,
  });
};

export const handleWarningToast = ({
  toastMessage,
  toastDescription,
  autoClose = 5000,
}: ToastProps) => {
  toastEventBus.emit({
    severity: 'warning',
    message: toastMessage,
    description: toastDescription,
    autoClose,
  });
};
